"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareCheckList = exports.hasCameraDevices = exports.handleUpdateVideoInput = exports.handleUpdateUserBackground = exports.handleTransformedVideoInput = exports.getWarningMessages = exports.getUserNameFromPresenterTitle = exports.getNotificationStatus = exports.getErrorMessages = exports.getCheckStatus = exports.formatDevicesArrayForDropdown = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _ReadinessCheckerMessaging = require("../../constants/ReadinessCheckerMessaging");
var _Join = require("../../constants/Join");
var _Sources = require("@studio/constants/Sources");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Do nothing function to be used as a default callback
var NO_OP = function NO_OP() {};

/**
 * Check if camera devices are available
 * @param {Array} videoInputDevices - Array of video input devices
 * @returns {boolean} - True if camera devices are available, false otherwise
 */
var hasCameraDevices = exports.hasCameraDevices = function hasCameraDevices(videoInputDevices) {
  if (videoInputDevices.length === 0) return false;
  return !(videoInputDevices.length === 1 && videoInputDevices[0].value === '' && videoInputDevices[0].label === 'No device found');
};

/**
 * Join component error messages from readinessCheck object
 * @param readinessCheck
 * @returns {*[]}
 */
var getErrorMessages = exports.getErrorMessages = function getErrorMessages(readinessCheck) {
  var errors = [];

  // example is { device: 'FAILED', browser: 'NO_DEVICE_FOUND', microphone: 'FAILED', connectivity: 'FAILED' }
  for (var _i = 0, _Object$entries = Object.entries(readinessCheck); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
      checkType = _Object$entries$_i[0],
      status = _Object$entries$_i[1];
    if (checkType === _ReadinessCheck.DEVICE_CHECK && [_ReadinessCheck.FAILED, _ReadinessCheck.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.USE_DIFFERENT_DEVICE);
    }
    if (checkType === _ReadinessCheck.BROWSER_CHECK && [_ReadinessCheck.FAILED, _ReadinessCheck.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.USE_DIFFERENT_BROWSER);
    }
    if (checkType === _ReadinessCheck.MICROPHONE_CHECK && [_ReadinessCheck.FAILED, _ReadinessCheck.NO_DEVICE_FOUND].includes(status)) {
      errors.push(_ReadinessCheckerMessaging.NO_MICROPHONE_FOUND);
    }
  }
  return errors;
};

/**
 * Join component warning messages from readinessCheck object
 * @param readinessCheck
 * @returns {*[]}
 */
var getWarningMessages = exports.getWarningMessages = function getWarningMessages(readinessCheck) {
  var warnings = [];
  // example is { device: 'FAILED', browser: 'NO_DEVICE_FOUND', microphone: 'FAILED', connectivity: 'FAILED' }
  for (var _i2 = 0, _Object$entries2 = Object.entries(readinessCheck); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i2], 2),
      checkType = _Object$entries2$_i[0],
      status = _Object$entries2$_i[1];
    if (checkType === _ReadinessCheck.CAMERA_CHECK && [_ReadinessCheck.FAILED, _ReadinessCheck.NO_DEVICE_FOUND, _ReadinessCheck.PERMISSION_DENIED].includes(status)) {
      warnings.push(_ReadinessCheckerMessaging.NO_CAMERA_FOUND);
    }
    if (checkType === _ReadinessCheck.CONNECTIVITY_CHECK && [_ReadinessCheck.FAILED, _ReadinessCheck.NO_DEVICE_FOUND, _ReadinessCheck.PERMISSION_DENIED].includes(status)) {
      warnings.push(_ReadinessCheckerMessaging.NETWORK_TRAFFIC_ERROR);
    }
    if (checkType === _ReadinessCheck.CAMERA_CHECK && status === _ReadinessCheck.IN_USE) {
      warnings.push(_ReadinessCheckerMessaging.CAMERA_IN_USE_MESSAGE);
    }
    if (checkType === _ReadinessCheck.MICROPHONE_CHECK && status === _ReadinessCheck.IN_USE) {
      warnings.push(_ReadinessCheckerMessaging.MICROPHONE_IN_USE_MESSAGE);
    }
  }
  return warnings;
};

/**
 * Get notification status based on readinessCheck object
 * @param readinessCheck
 * @param userRole
 * @param isStandaloneChecker
 * @param shouldJoinWithoutKnock
 * @returns {string}
 */
var getNotificationStatus = exports.getNotificationStatus = function getNotificationStatus(readinessCheck, userRole) {
  var isStandaloneChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var shouldJoinWithoutKnock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var errors = getErrorMessages(readinessCheck);
  var warnings = getWarningMessages(readinessCheck);
  var allChecksDone = Object.values(readinessCheck).every(function (value) {
    return value !== _ReadinessCheck.CHECKING;
  });
  var isAudioPermissionDenied = readinessCheck.microphone === _ReadinessCheck.PERMISSION_DENIED;
  var isVideoPermissionDenied = readinessCheck.camera === _ReadinessCheck.PERMISSION_DENIED;
  var isAVPermissionDenied = isAudioPermissionDenied || isVideoPermissionDenied;
  var isVideoAndAudioPermissionDenied = isAudioPermissionDenied && isVideoPermissionDenied;
  var isCameraInUse = readinessCheck.camera === _ReadinessCheck.IN_USE;
  var isMicrophoneInUse = readinessCheck.microphone === _ReadinessCheck.IN_USE;
  var hasIssues = (errors.length > 0 || warnings.length > 0) && allChecksDone && !isAVPermissionDenied;
  var allOk = errors.length === 0 && warnings.length === 0 && allChecksDone && !isAVPermissionDenied;
  var isAllOkStandAlone = isStandaloneChecker && allOk;
  var allOkMessage = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _Sources.SOURCE_ROLE_HOST, _Join.ALL_OK_HOST), _Sources.SOURCE_ROLE_SPEAKER, shouldJoinWithoutKnock ? _Join.ALL_OK_HOST : _Join.ALL_OK_SPEAKER);

  // The switch/case is in order of priority of notifications to be shown
  switch (true) {
    case isVideoAndAudioPermissionDenied:
      return _Join.AUDIO_VIDEO_PERMISSION_DENIED;
    case isAudioPermissionDenied:
      return _Join.AUDIO_PERMISSION_DENIED;
    case isVideoPermissionDenied:
      return _Join.VIDEO_PERMISSION_DENIED;
    case isMicrophoneInUse:
      return _Join.MICROPHONE_IN_USE_NOTIFICATION;
    case isCameraInUse:
      return _Join.CAMERA_IN_USE_NOTIFICATION;
    case hasIssues:
      return _Join.READINESS_ISSUES;
    case isAllOkStandAlone:
      return _Join.ALL_OK_STANDALONE;
    case allOk:
      return allOkMessage[userRole];
    default:
      return _Join.NO_NOTIFICATION;
  }
};

/**
 * Formats the devices array to be used in the form dropdown
 * @param devices
 * @returns {*}
 */
var formatDevicesArrayForDropdown = exports.formatDevicesArrayForDropdown = function formatDevicesArrayForDropdown(devices) {
  // Blocked devices
  if (devices.length === 1 && devices[0].label === '') {
    return [{
      label: 'No device found',
      value: ''
    }];
  }

  // No devices at all
  if (devices.length === 0) {
    return [{
      label: 'No device found',
      value: ''
    }];
  }
  return devices.map(function (device) {
    return {
      label: device.label,
      value: device.deviceId,
      group: device.groupId
    };
  });
};

/**
 * Handles transformed video input, formats it and deletes it if not needed
 * @param userBackground
 * @param transformedVideoInput
 * @param setTransformedVideoInput
 * @param clearBackgroundFilter
 * @returns {Promise<*[]>}
 */
var handleTransformedVideoInput = exports.handleTransformedVideoInput = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(userBackground, transformedVideoInput, setTransformedVideoInput, clearBackgroundFilter) {
    var transformedVideoInputs, _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          transformedVideoInputs = [];
          if (!(userBackground === _VirtualBackground.BACKGROUND_OPTIONS.NONE && transformedVideoInput !== null)) {
            _context.next = 5;
            break;
          }
          transformedVideoInputs = [];
          setTransformedVideoInput(null);
          _context.prev = 1;
          _context.next = 2;
          return clearBackgroundFilter(transformedVideoInput);
        case 2:
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          console.error('Error resetting transformed video input', _t);
        case 4:
          _context.next = 6;
          break;
        case 5:
          transformedVideoInputs = transformedVideoInput === null ? [] : [transformedVideoInput];
        case 6:
          return _context.abrupt("return", transformedVideoInputs);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function handleTransformedVideoInput(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Determines the status of the join page based on the completed checklist and errors
 * @param completedCheckList
 * @param errors
 * @returns {string}
 */
var getCheckStatus = exports.getCheckStatus = function getCheckStatus(completedCheckList, errors) {
  var allChecksDone = Object.values(completedCheckList).every(function (value) {
    return value !== _ReadinessCheck.CHECKING;
  });
  var isAudioPermissionDenied = completedCheckList.microphone === _ReadinessCheck.PERMISSION_DENIED;
  if (isAudioPermissionDenied) {
    return _Join.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  }
  if (errors.length > 0) {
    return _Join.JOIN_PAGE_STATUS.ERROR;
  }
  if (allChecksDone && errors.length === 0) {
    return _Join.JOIN_PAGE_STATUS.COMPLETE;
  }
  return _Join.JOIN_PAGE_STATUS.IN_PROGRESS;
};

/**
 * Prepares the checklist for the join component
 * @param readinessCheck
 * @param shouldRequireAudio
 * @returns {*&{microphone: (*|string)}}
 */
var prepareCheckList = exports.prepareCheckList = function prepareCheckList(readinessCheck, shouldRequireAudio) {
  var completedCheckList = _objectSpread(_objectSpread({}, readinessCheck), {}, {
    microphone: shouldRequireAudio ? readinessCheck.microphone : _ReadinessCheck.PASSED
  });
  delete completedCheckList.screenShare;
  delete completedCheckList.speaker;
  return completedCheckList;
};

/**
 * Updates the video input device with appropriate background settings
 * @param {Function} setUserBackgroundLoading - State setter for background loading status
 * @param {string} userBackground - Selected background option (BLUR, NONE, etc.)
 * @param {MediaStream|null} transformedVideoInput - The transformed video stream if any
 * @param {Function} setSelectedVideoInput - State setter for selected video input
 * @param {Function} setTransformedVideoInput - State setter for transformed video input
 * @param {Object|string} videoInputDevice - The video input device to use
 * @param {Function} getVideoInput - Function to retrieve the video input based on the background option
 * @param {string} backgroundUrl - Optional URL for custom background image
 * @returns {Promise<void>}
 */
var handleUpdateVideoInput = exports.handleUpdateVideoInput = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(setUserBackgroundLoading, userBackground, transformedVideoInput, setSelectedVideoInput, setTransformedVideoInput, videoInputDevice, getVideoInput) {
    var backgroundUrl,
      isPreview,
      _videoInputDevice$dev,
      videoInput,
      _args2 = arguments,
      _t2;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          backgroundUrl = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : '';
          isPreview = _args2.length > 8 && _args2[8] !== undefined ? _args2[8] : false;
          _context2.prev = 1;
          setUserBackgroundLoading(true);
          _context2.next = 2;
          return getVideoInput(userBackground, transformedVideoInput, (_videoInputDevice$dev = videoInputDevice.device) !== null && _videoInputDevice$dev !== void 0 ? _videoInputDevice$dev : videoInputDevice, NO_OP, backgroundUrl, isPreview);
        case 2:
          videoInput = _context2.sent;
          setSelectedVideoInput(videoInput);
          if (userBackground !== _VirtualBackground.BACKGROUND_OPTIONS.NONE) {
            setTransformedVideoInput(videoInput);
          } else {
            setTransformedVideoInput(null);
          }
          _context2.next = 4;
          break;
        case 3:
          _context2.prev = 3;
          _t2 = _context2["catch"](1);
          console.error('Error updating user background:', _t2);
        case 4:
          _context2.prev = 4;
          setUserBackgroundLoading(false);
          return _context2.finish(4);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 3, 4, 5]]);
  }));
  return function handleUpdateVideoInput(_x5, _x6, _x7, _x8, _x9, _x0, _x1) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Updates the user's background setting and applies it to the video input
 * @param {Function} setUserBackgroundLoading - State setter for background loading status
 * @param {MediaStream|null} transformedVideoInput - The transformed video stream if any
 * @param {Object} selectedVideoInput - The currently selected video input
 * @param {Function} setUserBackground - State setter for user background option
 * @param {Function} setSelectedVideoInput - State setter for selected video input
 * @param {Function} setTransformedVideoInput - State setter for transformed video input
 * @param {string} backgroundOption - The background option to apply (BLUR, NONE, etc.)
 * @param {Function} getVideoInput - Function to retrieve the video input based on the background option
 * @param {string} backgroundUrl - Optional URL for custom background image
 * @param {Object} currentVideoTrack - Current video track
 * @param {boolean} isPreview - If true, uses preview processor instead of main processor
 * @returns {Promise<void>}
 */
var handleUpdateUserBackground = exports.handleUpdateUserBackground = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(setUserBackgroundLoading, transformedVideoInput, selectedVideoInput, setUserBackground, setSelectedVideoInput, setTransformedVideoInput, backgroundOption, getVideoInput) {
    var backgroundUrl,
      isPreview,
      _selectedVideoInput$d,
      videoInput,
      _args3 = arguments,
      _t3;
    return _regenerator["default"].wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          backgroundUrl = _args3.length > 8 && _args3[8] !== undefined ? _args3[8] : '';
          isPreview = _args3.length > 9 && _args3[9] !== undefined ? _args3[9] : false;
          _context3.prev = 1;
          setUserBackgroundLoading(true);
          _context3.next = 2;
          return getVideoInput(backgroundOption, transformedVideoInput, (_selectedVideoInput$d = selectedVideoInput.device) !== null && _selectedVideoInput$d !== void 0 ? _selectedVideoInput$d : selectedVideoInput, NO_OP,
          // No action needed for this callback
          backgroundUrl, isPreview);
        case 2:
          videoInput = _context3.sent;
          setUserBackground(backgroundOption);
          setSelectedVideoInput(videoInput);
          if (backgroundOption !== _VirtualBackground.BACKGROUND_OPTIONS.NONE) {
            setTransformedVideoInput(videoInput);
          } else {
            setTransformedVideoInput(null);
          }
          _context3.next = 4;
          break;
        case 3:
          _context3.prev = 3;
          _t3 = _context3["catch"](1);
          console.error('Error updating user background:', _t3);
        case 4:
          _context3.prev = 4;
          setUserBackgroundLoading(false);
          return _context3.finish(4);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 3, 4, 5]]);
  }));
  return function handleUpdateUserBackground(_x10, _x11, _x12, _x13, _x14, _x15, _x16, _x17) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Extracts first and last names from a full presenter title string
 * @param presenterTitle
 * @returns {{firstName: (*|string), lastName: (*|string)}}
 */
var getUserNameFromPresenterTitle = exports.getUserNameFromPresenterTitle = function getUserNameFromPresenterTitle(presenterTitle) {
  var names = presenterTitle.split(' ');
  return {
    firstName: names[0] || '',
    lastName: names.slice(1).join(' ') || ''
  };
};